import type { Capability } from 'owa-capabilities';
import type { MailboxInfo } from 'owa-client-types';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import { isAccountFeatureEnabled } from 'owa-feature-flags';
/* eslint-disable-next-line @typescript-eslint/no-restricted-imports  -- (https://aka.ms/OWALintWiki)
 * Deprecating getPhysicalRing.ts
 *	> 'isEnvironmentAirGap' import from 'owa-metatags' is restricted. This value is resolved in ECS as a filter. Please create a feature flight if possible. */
import { isEnvironmentAirGap } from 'owa-metatags';
import getModuleContextMailboxInfo from 'owa-module-context-mailboxinfo/lib/selectors/getModuleContextMailboxInfo';
import { isOptionalExperiencesDisabledForPrivacy } from 'owa-privacy-utils/lib/selectors/isOptionalExperiencesDisabledForPrivacy';
import { getUserConfiguration, getAccountScopeUserSettings } from 'owa-session-store';
import getAggregatePolicyInfo from './utils/getAggregatePolicyInfo';

/**
 * NOTE: Please see the README for more information on how the
 * capability functions must be implemented and used.
 */
export const feedbackCapability: Capability = {
    isEnabled: (_mailboxInfo?: MailboxInfo) => {
        // get the user options for the primary account
        const { PolicySettings } = getUserConfiguration();
        return !!PolicySettings?.FeedbackEnabled;
    },
    isSupported: (mailboxInfo?: MailboxInfo) => {
        const policies = getAggregatePolicyInfo('isFeedbackEnabled');
        const isfeedbackPolicyEnabled = policies['isFeedbackEnabled'] as boolean;
        const isFeatureEnabledForUser = isAccountFeatureEnabled(
            'mon-diag-feedbackjs',
            getGlobalSettingsAccountMailboxInfo()
        );
        const isDisabledForPrivacy = isOptionalExperiencesDisabledForPrivacy();
        const { IsConsumerChild } = getAccountScopeUserSettings(
            mailboxInfo ?? getModuleContextMailboxInfo()
        );

        const isFeedbackEnabledByPolicy = isfeedbackPolicyEnabled;
        return (
            isFeatureEnabledForUser &&
            !isEnvironmentAirGap() &&
            !IsConsumerChild &&
            isFeedbackEnabledByPolicy &&
            !isDisabledForPrivacy
        );
    },
};
